import { defineComponent as f, mergeModels as p, ref as m, useModel as b, onMounted as h, createElementBlock as g, openBlock as r, normalizeProps as v, guardReactiveProps as S, unref as a, createVNode as k, withDirectives as x, createBlock as s, createCommentVNode as y, createElementVNode as C, mergeProps as M, vModelText as V, withModifiers as z } from "vue";
import { ScalarIconMagnifyingGlass as B, ScalarIconX as w } from "@scalar/icons";
import { useBindCx as E } from "@scalar/use-hooks/useBindCx";
import I from "../ScalarLoading/ScalarLoading.vue.js";
import N from "../ScalarIconButton/ScalarIconButton.vue.js";
const P = ["aria-label"], D = /* @__PURE__ */ f({
  inheritAttrs: !1,
  __name: "ScalarSidebarSearchInput",
  props: /* @__PURE__ */ p({
    autofocus: { type: Boolean },
    loading: {},
    label: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const l = m(null), o = b(t, "modelValue");
    function i() {
      o.value = "", l.value && l.value.focus();
    }
    const { classCx: c, otherAttrs: u } = E();
    return h(() => {
      var e;
      return t.autofocus && ((e = l.value) == null ? void 0 : e.focus());
    }), (e, n) => (r(), g("label", v(S(
      a(c)(
        "flex items-center rounded border text-base has-[:focus-visible]:bg-b-1 has-[:focus-visible]:outline h-8 gap-1 pl-2 pr-1.5",
        "bg-sidebar-b-search border-sidebar-border-search",
        o.value ? "text-c-1" : "text-sidebar-c-search"
      )
    )), [
      k(a(B), { class: "text-sidebar-c-search size-4" }),
      x(C("input", M({
        ref_key: "inputRef",
        ref: l,
        "aria-label": e.label ?? "Enter search query",
        autocapitalize: "off",
        autocomplete: "off",
        autocorrect: "off",
        class: "flex-1 appearance-none rounded border-none bg-transparent outline-none",
        placeholder: "Search...",
        spellcheck: "false",
        type: "search"
      }, a(u), {
        "onUpdate:modelValue": n[0] || (n[0] = (d) => o.value = d)
      }), null, 16, P), [
        [V, o.value]
      ]),
      e.loading && e.loading.isLoading ? (r(), s(a(I), {
        key: 0,
        class: "mr-3 self-center",
        loadingState: e.loading,
        size: "md"
      }, null, 8, ["loadingState"])) : o.value ? (r(), s(a(N), {
        key: 1,
        class: "p-0.25 size-4",
        icon: a(w),
        weight: "bold",
        label: "Clear Search",
        onClick: z(i, ["stop", "prevent"])
      }, null, 8, ["icon"])) : y("", !0)
    ], 16));
  }
});
export {
  D as default
};
